import React, { useState, useEffect } from 'react';
import { Row, Col, } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import './AllFarmsSummary.css';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import FarmList from '../AllFarmsSummary/FarmList';
import ProgrammeSummary from '../AllFarmsSummary/ProgrammeSummary';
import OpenActionSummary from '../AllFarmsSummary/OpenActionSummary';

const AllFarmsSummary = ({ handleWizardFarmChanged }) => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));

    const [loading, setLoading] = useState(true);
    const [allFarmsSummary, setAllFarmsSummary] = useState({ farmsList: [], itemList: [], programmeSummary: {}, openActionSupplierList: [], openActionList: [], openActionsList: [], totalFarmDetails: {} });
    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await axios.get(
                '/api/AllFarmsSummary/GetAllFarmsSummaryDetails/', {
                params: { UserId: userId }
            }
            );
            setAllFarmsSummary({
                ...allFarmsSummary, farmsList: response.data.farmsList, programmeSummary: response.data.programmeSummary
                , openActionSupplierList: response.data.openActionSupplierList, openActionList: response.data.openActionList, openActionsList: response.data.openActionsList
                , totalFarmDetails: response.data.totalFarmDetails, itemList: response.data.allFarmOutlineList
            });
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }
    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h2>All Farms Summary</h2></Col>
            </Row>
            {loading ? <SpinnerContainer /> :
                <div>
                    <Row>
                        <Col sm="5">
                           {/* <ProgrammeSummary programmeSummary={allFarmsSummary.programmeSummary}></ProgrammeSummary> <br/>*/}
                            <OpenActionSummary openActionSupplierList={allFarmsSummary.openActionSupplierList} openActionList={allFarmsSummary.openActionList} openActionsList={allFarmsSummary.openActionsList}></OpenActionSummary>
                        </Col>
                        <Col sm="7">
                            <FarmList userId={userId} tempFarmsList={allFarmsSummary.farmsList} farmsList={allFarmsSummary.farmsList}
                                totalFarmDetails={allFarmsSummary.totalFarmDetails} itemModel={allFarmsSummary}
                                handleWizardFarmChanged={handleWizardFarmChanged}></FarmList>
                        </Col>
                    </Row>
                </div>
            }
        </div>
    )
}
export default AllFarmsSummary;